import axios from "axios";
import { PaginatedResponse } from "../types/api";
import { API_BASE_URL_NO_API } from "../utils/apiConfig";

const API_BASE_URL = API_BASE_URL_NO_API;

export interface UserApiResponse {
    id: number;
    username: string;
    email: string;
    name?: string;
    first_name?: string;
    last_name?: string;
    full_name?: string;
}

export type PaginatedUsersResponse = PaginatedResponse<UserApiResponse>;

export interface GetUsersParams {
    search?: string;
    page?: number;
    page_size?: number;
}

const getBaseUrl = () => {
    return API_BASE_URL.endsWith('/api') ? API_BASE_URL.slice(0, -4) : API_BASE_URL;
};

export const usersApi = {
    /**
     * Pobiera użytkowników z backendu z paginacją
     * @param params - Opcjonalne parametry wyszukiwania i paginacji
     * @returns Paginowana odpowiedź z API zawierająca count, next, previous i results
     */
    getUsers: async (params?: GetUsersParams): Promise<PaginatedUsersResponse> => {
        const queryParams = new URLSearchParams();
        if (params?.search) {
            queryParams.append("search", params.search);
        }
        if (params?.page) {
            queryParams.append("page", params.page.toString());
        }
        if (params?.page_size) {
            queryParams.append("page_size", params.page_size.toString());
        }

        const queryString = queryParams.toString();
        const baseUrl = getBaseUrl();
        const url = `${baseUrl}/api/users/${queryString ? `?${queryString}` : ""}`;

        const response = await axios.get<PaginatedResponse<UserApiResponse>>(url);
        return response.data;
    },

    /**
     * Pobiera szczegóły użytkownika po ID
     * @param id - ID użytkownika
     * @returns Szczegóły użytkownika
     */
    getUser: async (id: number): Promise<UserApiResponse> => {
        const baseUrl = getBaseUrl();
        const url = `${baseUrl}/api/users/${id}/`;
        const response = await axios.get<UserApiResponse>(url);
        return response.data;
    },
};
